<script setup>
import { useRoute } from 'vue-router';
/* import {Common} from '@/utils/common' */
import {computed, ref} from "vue";
import {useStore} from "vuex";

const store = useStore()
/* const LogOut = (() => {
  Common.LogOut()
}) */

// 로그인 admin 정보
const adminInfo = computed(() => store.getters.getAdminInfo)

// 미승인 의사 수
const acceptCount = computed(()=> store.getters.getAcceptYn)
const route = useRoute();


// 모바일 햄버거 메뉴 열림 여부
const menuOpen = ref(false)

const SurveyMngHover = ref(false)
const ContentsMngHover = ref(false)
const SupportMngHover = ref(false)
const SurveyResultHover = ref(false)
const isActiveEqual = (path) => {
  // 현재 라우트에 path 문자열이 일치하면 true
  return route.path === (path);
};
const isActiveIncludes = (path) => {
  // 현재 라우트에 path 문자열을 포함하면 true
  return route.path.includes(path);
};
</script>

<template>
  <!-- header -->
  <div class="header" :class="{'menu_open': menuOpen}">
    <h1><router-link to="/Dashboard"><img src="@/assets/img/wecareloco_white.svg" style="width: 15rem;"></router-link></h1>
    <ul class="nav" @click="menuOpen = false">

      <li class="getBadge" :class="isActiveEqual('/DoctorMng') ? 'on' : ''" v-show="adminInfo.admAuth === 'SUPER_ADMIN' || adminInfo.admAuth === 'HOSP_ADMIN'" style="position: relative; display: inline-block;">
        <router-link to="/DoctorMng">
          <span style="position: relative; display: inline-block;"><span class="badge" v-show="acceptCount !== 0 && adminInfo.admAuth === 'SUPER_ADMIN'">{{acceptCount}}</span>의료진 관리</span>
        </router-link>
      </li>

      <li :class="isActiveIncludes('/PatientMng') ? 'on' : ''">
        <router-link to="/PatientMng"><span>환자 관리</span></router-link>
      </li>

      <li :class="isActiveIncludes('/SurveyMng') || isActiveEqual('/ResearchMng') ? 'on' : ''" @mouseover="SurveyMngHover=true" @mouseout="SurveyMngHover=false">
        <router-link to="/SurveyMng"><span>설문 관리+</span></router-link>

        <ul class="sub_menu menu01" :class="SurveyMngHover == true ? 'active' : ''">
          <li :class="isActiveEqual('/SurveyMng') ? 'on' : ''"><router-link to="/SurveyMng"><span>개별 설문 관리</span></router-link></li>
          <li :class="isActiveEqual('/SurveyMngGrp') ? 'on' : ''"><router-link to="/SurveyMngGrp"><span>그룹 설문 관리</span></router-link></li>
          <li :class="isActiveEqual('/SurveyMngRes') ? 'on' : ''"><router-link to="/SurveyMngRes"><span>연구 설문 관리</span></router-link></li>
          <li v-show="adminInfo.admAuth === 'SUPER_ADMIN' || adminInfo.admAuth === 'HOST_ADMIN'" :class="isActiveEqual('/ResearchMng') ? 'on' : ''"><router-link to="/ResearchMng"><span>연구 관리</span></router-link></li>
        </ul>
      </li>

      <li :class="isActiveEqual('/SurveyResult') || isActiveEqual('/ViewData') ? 'on' : ''" @mouseover="SurveyResultHover=true" @mouseout="SurveyResultHover=false">
        <router-link to="/SurveyResult"><span>설문 결과+</span></router-link>

        <ul class="sub_menu menu04" :class="SurveyResultHover == true ? 'active' : ''">
          <li :class="isActiveEqual('/SurveyResult') ? 'on' : ''"><router-link to="/SurveyResult"><span>설문 결과</span></router-link></li>
          <li :class="isActiveEqual('/ViewData') ? 'on' : ''"><router-link to="/ViewData"><span>데이터 조회</span></router-link></li>
        </ul>
      </li>

      <li :class="isActiveIncludes('/Notification') ? 'on' : ''" v-show="adminInfo.admAuth === 'SUPER_ADMIN' || adminInfo.admAuth === 'HOSP_ADMIN'">
        <router-link to="/NotificationRules"><span>알림 관리</span></router-link>
      </li>

      <li :class="isActiveIncludes('/ContentsMng') || isActiveIncludes('/ContentsPresetMng') ? 'on' : ''" @mouseover="ContentsMngHover=true" @mouseout="ContentsMngHover=false">
        <router-link to="/ContentsMng"><span>콘텐츠 관리+</span></router-link>
        <ul class="sub_menu menu02" :class="ContentsMngHover == true ? 'active' : ''">
          <li :class="isActiveIncludes('/ContentsMng') ? 'on' : ''"><router-link to="/ContentsMng"><span>콘텐츠 관리</span></router-link></li>
          <li :class="isActiveIncludes('/ContentsPresetMng') ? 'on' : ''"><router-link to="/ContentsPresetMng"><span>콘텐츠 프리셋 관리</span></router-link></li>
        </ul>
      </li>

      <li :class="isActiveEqual('/QnABoard') || isActiveIncludes('/FAQMng') || isActiveEqual('/ShoppingHelpService') ? 'on' : ''" @mouseover="SupportMngHover = true" @mouseout="SupportMngHover = false">
        <router-link to="/QnABoard"><span>환자지원 관리+</span></router-link>
        <ul class="sub_menu menu03" :class="SupportMngHover === true ? 'active' : ''">
          <li :class="isActiveEqual('/QnABoard') ? 'on' : ''"><router-link to="/QnABoard"><span>문의 관리</span></router-link></li>
          <li :class="isActiveIncludes('/FAQMng') ? 'on' : ''"><router-link to="/FAQMng"><span>FAQ 관리</span></router-link></li>
          <li :class="isActiveEqual('/ShoppingHelpService') ? 'on' : ''"><router-link to="/ShoppingHelpService"><span>쇼핑‧도움서비스</span></router-link></li>
        </ul>
      </li>

      <li :class="isActiveIncludes('/Board') ? 'on' : ''">
        <router-link to="/BoardMng"><span>게시판</span></router-link>
      </li>

      <li :class="isActiveEqual('/ResearchIntro') ? 'on' : ''">
        <router-link to="/ResearchIntro"><span>연구회 소개</span></router-link>
      </li>
    </ul>
    <ul class="top_links">
      <li>
        <router-link to="/MyInfoMng" class="btn_modify"><span>내정보 관리</span></router-link>
      </li>
      <li>
        <router-link to="/LogOut" class="btn_logout"><span>내정보 관리</span></router-link>
      </li>
    </ul>
    <button type="button" class="btn_mobile_menu" title="메뉴" @click="menuOpen = !menuOpen">&#9776;</button>
  </div>
  <!-- //header -->
</template>

<style scoped>
.badge{
  position: absolute;
  top: -0.5rem;
  right: -1.5rem;
  background-color: #FF3B30;
  color: white;
  border-radius: 50%;
  width: 1.6rem;
  height: 1.6rem;
  font-size: 1.2rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none; /* 뱃지 클릭 막기 */
}
</style>
